import { useState, useEffect } from "react";
import Select from "react-select";

const PreferredDriverSetting = ({
    preferredDriverSettings,
    employees,
    saveMerchantPreferredDriverSetting,
}) => {
    const [enabled, setEnabled] = useState(false);
    const [radiusKm, setRadiusKm] = useState(5);
    const [switchWindowMinutes, setSwitchWindowMinutes] = useState(5);
    const [selectedEmployees, setSelectedEmployees] = useState([]);

    useEffect(() => {
        setEnabled(!!preferredDriverSettings?.enabled);
        setRadiusKm(preferredDriverSettings?.radiusKm ?? 5);
        setSwitchWindowMinutes(preferredDriverSettings?.switchWindowMinutes ?? 5);

        const allowedIds = Array.isArray(preferredDriverSettings?.allowedEmployeeIds)
            ? preferredDriverSettings.allowedEmployeeIds.map((id) =>
                typeof id === "object" ? id?._id ?? id?.toString() : id,
            )
            : [];

        setSelectedEmployees(
            (employees ?? []).filter((emp) => allowedIds.includes(emp?._id)),
        );
        // eslint-disable-next-line
    }, [preferredDriverSettings, employees]);

    const employeeOptions = (employees ?? []).map((emp) => ({
        label: `${emp?.name ?? ""} (${emp?.email ?? ""})`,
        value: emp?._id,
    }));

    const selectedOptions = selectedEmployees.map((emp) => ({
        label: `${emp?.name ?? ""} (${emp?.email ?? ""})`,
        value: emp?._id,
    }));

    const handleSave = () => {
        saveMerchantPreferredDriverSetting({
            enabled,
            radiusKm: Number(radiusKm),
            switchWindowMinutes: Number(switchWindowMinutes),
            allowedEmployeeIds: selectedEmployees.map((emp) => emp?._id),
        });
    };

    return (
        <div className="row g-5 g-lg-10 mt-4">
            <div className="col p-0 mb-xl-10">
                <h1 className="d-flex text-dark fw-bold m-0 fs-3 mb-5">
                    Preferred Driver Selection
                </h1>

                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <h5 className="mb-1 fw-bold">
                                    Enable Preferred Driver Selection
                                </h5>
                                <p className="text-muted mb-0">
                                    When enabled, selected employees can choose a preferred
                                    driver while placing an order (and switch the driver
                                    shortly after), bypassing automatic dispatch for that
                                    order.
                                </p>
                            </div>

                            <div className="form-check form-switch form-check-custom form-check-solid">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="preferredDriverEnabled"
                                    checked={enabled}
                                    onChange={(e) => setEnabled(e.target.checked)}
                                />
                            </div>
                        </div>

                        <div className="mt-4">
                            <span
                                className={`badge ${enabled ? "badge-light-success" : "badge-light-danger"
                                    }`}
                            >
                                {enabled ? "Enabled" : "Disabled"}
                            </span>
                        </div>

                        {enabled && (
                            <>
                                <div className="row mt-6">
                                    <div className="col-md-6">
                                        <label className="form-label">
                                            Driver Search Radius (km)
                                        </label>
                                        <input
                                            type="number"
                                            min="1"
                                            step="0.5"
                                            className="form-control"
                                            value={radiusKm}
                                            onChange={(e) => setRadiusKm(e.target.value)}
                                        />
                                        <small className="text-muted">
                                            All drivers within this radius of the branch will be
                                            listed for the employee to choose from.
                                        </small>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">
                                            Switch Driver Window (minutes)
                                        </label>
                                        <input
                                            type="number"
                                            min="1"
                                            step="1"
                                            className="form-control"
                                            value={switchWindowMinutes}
                                            onChange={(e) => setSwitchWindowMinutes(e.target.value)}
                                        />
                                        <small className="text-muted">
                                            After order placement, employees can switch the
                                            assigned driver only within this many minutes.
                                        </small>
                                    </div>
                                </div>

                                <div className="row mt-4">
                                    <div className="col-md-12">
                                        <label className="form-label">
                                            Employees Allowed to Select Preferred Driver
                                        </label>
                                        <Select
                                            isMulti
                                            className="react-select-styled react-select-bordered"
                                            classNamePrefix="react-select"
                                            options={employeeOptions}
                                            value={selectedOptions}
                                            onChange={(selected) => {
                                                const selectedIds = (selected ?? []).map(
                                                    (item) => item.value,
                                                );
                                                setSelectedEmployees(
                                                    (employees ?? []).filter((emp) =>
                                                        selectedIds.includes(emp?._id),
                                                    ),
                                                );
                                            }}
                                            placeholder="Select employees"
                                        />
                                    </div>
                                </div>
                            </>
                        )}

                        <div className="mt-6 d-flex justify-content-end">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleSave}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PreferredDriverSetting;